import React, { useEffect } from 'react'

import Version1 from './invoicing_software/Version1'
import Version2 from './invoicing_software/Version2'

export default function InvoicingSoftwareTab({
  canManageInvoicingOnboarding, acceptSignedContractPath, cancelOnboardingPath,
  completeAuthorizationPath, downloadFilePath, flashMessageRef,
  generateContractPath, getInvoicingSoftwareDataPath, invoicingSoftwareData,
  notifyCustomerForApiKeysPath, rejectAuthorizationPath, rejectContractPath,
  rejectInfoPath, rejectStatementPath, saveApiIntegrationKeysPath,
  sendInvoicingSoftwareEmailPath, setInvoicingSoftwareData, loading, setLoading,
  skipInvoicingOnboardingPath, canSkipInvoicingOnboarding, updateSettingsPath, uploadContractPath,
  invoicingStatusUpdatePath
}) {

  useEffect( () => {
    if (!invoicingSoftwareData) {
      setLoading(true)

      Rails.ajax({
        type: 'GET',
        url: getInvoicingSoftwareDataPath,
        dataType: 'json',
        success: res => {
          setInvoicingSoftwareData(res.invoicingSoftwareData)
          setLoading(false)
        },
        error: res => {
          flashMessageRef.current.show(res.error, 'error')
          setLoading(false)
        }
      })
    }
  }, [])

  if (invoicingSoftwareData) {
    if (invoicingSoftwareData.onboardingVersion === 'v2') {
      return (
        <Version2
          { ...invoicingSoftwareData }
          canManageInvoicingOnboarding={ canManageInvoicingOnboarding }
          notifyCustomerForApiKeysPath={ notifyCustomerForApiKeysPath }
          saveApiIntegrationKeysPath={ saveApiIntegrationKeysPath }
          invoicingStatusUpdatePath={ invoicingStatusUpdatePath }
          cancelOnboardingPath={ cancelOnboardingPath }
          skipInvoicingOnboardingPath={ skipInvoicingOnboardingPath }
          canSkipInvoicingOnboarding={ canSkipInvoicingOnboarding }
          setInvoicingSoftwareData={ setInvoicingSoftwareData }
          loading={ loading }
          setLoading={ setLoading }
          flashMessageRef={ flashMessageRef }
        />
      )
    } else {
      return (
        <Version1
          { ...invoicingSoftwareData }
          canManageInvoicingOnboarding={ canManageInvoicingOnboarding }
          acceptSignedContractPath={ acceptSignedContractPath }
          cancelOnboardingPath={ cancelOnboardingPath }
          completeAuthorizationPath={ completeAuthorizationPath }
          downloadFilePath={ downloadFilePath }
          generateContractPath={ generateContractPath }
          hideNotes
          notifyCustomerForApiKeysPath={ notifyCustomerForApiKeysPath }
          rejectAuthorizationPath={ rejectAuthorizationPath }
          rejectContractPath={ rejectContractPath }
          rejectInfoPath={ rejectInfoPath }
          rejectStatementPath={ rejectStatementPath }
          saveApiIntegrationKeysPath={ saveApiIntegrationKeysPath }
          sendInvoicingSoftwareEmailPath={ sendInvoicingSoftwareEmailPath }
          skipInvoicingOnboardingPath={ skipInvoicingOnboardingPath }
          updateSettingsPath={ updateSettingsPath }
          uploadContractPath={ uploadContractPath }
        />
      )
    }

  } else {
    return null
  }
}
